import { render } from "./MainLogin.vue?vue&type=template&id=2231a080&scoped=true&ts=true"
import script from "./MainLogin.vue?vue&type=script&lang=ts"
export * from "./MainLogin.vue?vue&type=script&lang=ts"

import "./login.css?vue&type=style&index=0&id=2231a080&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2231a080"]])

export default __exports__